import http from '@/api/http'

import {
  GetAccessContextPayload,
  GetAccessContextResponse,
  GetRedemptionStatusPayload,
  GetRedemptionStatusResponse,
  RedeemAccessCodePayload,
  RedeemAccessCodeResponse,
} from './types'

export const getAccessContext = async (
  payload: GetAccessContextPayload
): Promise<GetAccessContextResponse> => {
  const { chargingPointId } = payload

  const response = await http.get<GetAccessContextResponse>(
    `/charging/charging-point/${chargingPointId}/access-context/`
  )
  return response.data
}

export const redeemAccessCode = async (
  payload: RedeemAccessCodePayload
): Promise<RedeemAccessCodeResponse> => {
  const response = await http.post<RedeemAccessCodeResponse, RedeemAccessCodePayload>(
    '/users/access-codes/redeem/',
    payload
  )
  return response.data
}

export const getRedemptionStatus = async (
  payload: GetRedemptionStatusPayload
): Promise<GetRedemptionStatusResponse> => {
  const { redemptionId } = payload

  const response = await http.get<GetRedemptionStatusResponse>(
    `/users/access-codes/redemptions/${redemptionId}/`
  )
  return response.data
}
